import { PermissaoEnum } from '../enums/permissao.enum';

export const all = (prefix?: string): number[] => {
  return Object.entries(PermissaoEnum)
    .filter(([, value]) => typeof value === 'number') // ignora reverse mapping do enum
    .filter(([key]) => !prefix || key.startsWith(prefix))
    .map(([, value]) => value as number);
};
